<template>
  <div v-if="demandeLogistique && anneeSemaine">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3" >
                {{ $t('gestionAffectation.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button"
               @click="$router.go(-1)">
              {{ $t('gestionAffectation.actions.cancel') }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="mgt-20px column is-12 column is-narrow">
        <affectation-of-demande :demandeLogistique="demandeLogistique"
                                 :affectations="affectations"
                                 :filtres="filtres"
                                 @makeRecherche="makeRecherche($event)">
        </affectation-of-demande>
      </div>
      <div class="mgt-20px column is-12 overflow-x-hidden">
        <tab-tournee-face-semaine :ref="referenceTable"
                        :referenceTable="referenceTable"
                        :filtres="filtres"
                        :actions="actions"
                        :demandeLogistiqueId="demandeLogistique.id"
                        :anneeSemaine="anneeSemaine"
                        :referenceProduitReseau="demandeLogistique.ligneCommande?
                          demandeLogistique.ligneCommande.produitId:
                          demandeLogistique.produit.id"
                        :typeDonnee="EXPORT_EXCEL_AFFECTATION_LOGISTIQUE"
                        :isGestionAffectations="true"
                        @reloadAffectationReseauWithFilter="loadAffectationReseau">
        </tab-tournee-face-semaine>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { get } from '@/api/logistique/demandeLogistique/index';
import messageErreur from '@/services/general/messageErreur';
import breadcrumb from '@/components/general/breadcrumb';
import tabTourneeFaceSemaine from '@/components/logistique/affectation/tabTourneeFaceSemaine';
import affectationOfDemande from '@/components/logistique/affectation/affectationOfDemande';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import { getAll } from '@/api/logistique/tourneeFaceSemaine/index';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import { CATEGORIE_REGROUPEMENT_MAIRIE } from '@/configuration/catalogue/produitConf';
import * as actionsConf from '@/configuration/logistique/facesDisponible/facesDisponibleConf';
import { REFERENCE_TABLE_GESTION_DEMANDE_MANUEL_AFFECTATION } from '@/configuration/general/referenceTableConf';

const Societe = createNamespacedHelpers('societe');
const TourneeFaceSemaine = createNamespacedHelpers('tourneeFaceSemaine');

export default {
  name: 'm_affectationDemande',
  data() {
    return {
      demandeLogistique: null,
      affectations: [],
      anneeSemaine: null,
      filtres: {
        estAffecteReseau: true,
      },
      actions: [
        { action: actionsConf.ACTION_AFFICHAGE, translation: 'faceDisponible.actions.actionAffichage' },
        { action: actionsConf.ACTION_INSTRUCTION_POSE, translation: 'faceDisponible.actions.instructionPose' },
        { action: actionsConf.ACTION_LAISSER_EN_PLACE, translation: 'faceDisponible.actions.laisserEnPlace' },
        { action: actionsConf.ACTION_ENLEVER_LAISSER_EN_PLACE, translation: 'faceDisponible.actions.enleverLaisserEnPlace' },
      ],
      EXPORT_EXCEL_AFFECTATION_LOGISTIQUE: actionsConf.EXPORT_EXCEL_AFFECTATION_LOGISTIQUE,
      referenceTable: REFERENCE_TABLE_GESTION_DEMANDE_MANUEL_AFFECTATION,
    };
  },
  components: {
    breadcrumb,
    tabTourneeFaceSemaine,
    affectationOfDemande,
  },
  methods: {
    ...TourneeFaceSemaine.mapActions({
      actionLoadTourneeFaceSemaine: 'loadTourneeFaceSemaine',
    }),
    async loadAffectationReseau() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const affectations = (await getAll({
          limit: NO_PAGINATION,
          query: {
            actif: true,
            anneeSemaine: this.anneeSemaine,
            societeId: this.societeActiveId,
            demandeLogistiqueIds: [this.demandeLogistique.id],
            avecNonCommercialisable: this.demandeLogistique.typeProduit
             === CATEGORIE_REGROUPEMENT_MAIRIE,
          },
        })).data.result.items;
        this.affectations = affectations;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    makeRecherche(filtreUpdate) {
      if (this.filtres[filtreUpdate]) {
        this.$refs[this.referenceTable].initFilters(null);
      } else {
        this.$refs[this.referenceTable].recherche();
      }
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...TourneeFaceSemaine.mapGetters({
      tourneeFaceSemaine: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('gestionAffectation.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('gestionAffectation.breadcrumb.listeDemande'), route: { name: 'l.logistique.demande-manuel' }, isActive: false },
        { title: this.$i18n.t('gestionAffectation.breadcrumb.gestionAffectation'), route: '', isActive: true },
      ];
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.demandeLogistique = (await get(this.$route.params.idDemande)).data.result;
      if (this.demandeLogistique.typeProduit === CATEGORIE_REGROUPEMENT_MAIRIE) {
        this.filtres.avecNonCommercialisable = true;
      }
      this.anneeSemaine = Number(getAnneeSemaineFromDate(this.demandeLogistique.datePlanification));
      this.critereRecherche.avecLaisserEnPlaceVente = null;
      this.critereRecherche.afficheurIds = [];
      this.critereRecherche.sansAfficheur = null;
      await this.loadAffectationReseau();
      this.setInformationPage(this.$t('pageLogistique.demande.gestionAffectation'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
